<template>
  <v-card
    class="tarjeta-dias"
    :class="[claseUrgencia, embebida ? 'tarjeta-dias--embebida' : 'shadowCard']"
  >
    <v-card-text class="pa-5 white--text">
      <div class="dias-periodo">
        <v-icon small color="white" class="mr-1">mdi-calendar-range</v-icon>
        Periodo de inscripción
      </div>

      <div class="dias-fechas">
        <span class="dias-fecha">{{ fechaInicio || '—' }}</span>
        <v-icon x-small color="white" class="mx-2">mdi-arrow-right</v-icon>
        <span class="dias-fecha">{{ fechaFin || '—' }}</span>
      </div>

      <div class="dias-contador">
        <div class="dias-numero">{{ etiquetaNumero }}</div>
        <div class="dias-texto">{{ etiquetaDias }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TarjetaDiasInscripcion',

  props: {
    fechaInicio: { type: String, default: '' },
    fechaFin: { type: String, default: '' },
    dias: { type: [Number, String], default: null },
    embebida: { type: Boolean, default: false },
  },

  computed: {
    diasNum() {
      const n = Number(this.dias)
      return Number.isFinite(n) ? n : null
    },
    claseUrgencia() {
      if (this.diasNum == null) return ''
      if (this.diasNum <= 0) return 'tarjeta-dias--cerrado'
      if (this.diasNum <= 7) return 'tarjeta-dias--urgente'
      return ''
    },
    etiquetaNumero() {
      if (this.diasNum == null) return '—'
      if (this.diasNum <= 0) return '0'
      return String(this.diasNum)
    },
    etiquetaDias() {
      if (this.diasNum == null) return 'días para inscribir'
      if (this.diasNum <= 0) return 'periodo cerrado'
      if (this.diasNum === 1) return 'día para inscribir'
      return 'días para inscribir'
    },
  },
}
</script>

<style scoped>
.tarjeta-dias {
  background: linear-gradient(135deg, #0d47a1 0%, #1565c0 55%, #1e88e5 100%) !important;
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(13, 71, 161, 0.28) !important;
}

.tarjeta-dias--urgente {
  background: linear-gradient(135deg, #e65100 0%, #ef6c00 55%, #fb8c00 100%) !important;
  box-shadow: 0 10px 24px rgba(239, 108, 0, 0.32) !important;
}

.tarjeta-dias--cerrado {
  background: linear-gradient(135deg, #37474f 0%, #546e7a 100%) !important;
  box-shadow: 0 10px 24px rgba(55, 71, 79, 0.28) !important;
}

.dias-periodo {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  opacity: 0.9;
  margin-bottom: 8px;
}

.dias-fechas {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.dias-fecha {
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 600;
}

.dias-contador {
  text-align: center;
}

.dias-numero {
  font-size: 3.4rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -1px;
}

.dias-texto {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 500;
  opacity: 0.95;
}

.tarjeta-dias--embebida {
  box-shadow: none !important;
}

.tarjeta-dias--embebida >>> .v-card__text {
  padding: 16px 12px !important;
}

.tarjeta-dias--embebida .dias-numero {
  font-size: 2.6rem;
}
</style>
